export default __webpack_public_path__ + "icon_road.466853dd280c090330504823935b368f.svg";